import {
  OVERVIEW_ACCENTS,
  type OverviewAccent
} from "../../../Lead/LeadWorkspacePage/overview/OverviewCardIcon.tsx"

const ACCENT_KEYS = Object.keys(OVERVIEW_ACCENTS) as OverviewAccent[]

/**
 * Deterministic per-customer color from the same pastel palette already used
 * for Lead Overview cards — the same row always gets the same avatar color
 * across reloads and pagination, without adding a new color system.
 */
const accentForCustomer = (id: string): OverviewAccent => {
  let hash = 0
  for (let i = 0; i < id.length; i++)
    hash = (hash * 31 + id.charCodeAt(i)) >>> 0
  return ACCENT_KEYS[hash % ACCENT_KEYS.length]
}

export { accentForCustomer }
